import { api } from "../../api/client.ts";
import { t } from "../../i18n/index.ts";
import { useAction } from "../../lib/resource.ts";
import { loadMe, me } from "../../lib/state.ts";
import { ConfirmButton } from "../../ui/Dialog.tsx";
import { CopyButton } from "../../ui/misc.tsx";

interface Props {
  space: string;
  user: string;
  address: string;
}

/** Copy, and "new address" for a member's personal triage email address (rotation invalidates the old one). */
export function TriageEmailAddressActions(p: Props) {
  const [rotate, busy] = useAction(async () => {
    await api.post(`/spaces/${p.space}/triage-email-addresses/${p.user}`);
    if (p.user === me.value?.id) {
      await loadMe(); // my addresses live in /me
    }
  });
  return (
    <>
      <CopyButton text={p.address} label={t("common.copy")} />
      <ConfirmButton
        size="sm"
        label={t("settings.rotate")}
        title={t("settings.rotate")}
        message={t("settings.rotateMessage")}
        confirmLabel={t("settings.rotate")}
        busy={busy}
        onConfirm={rotate}
      />
    </>
  );
}

/** A personal triage email address. */
export const Address = ({ address }: { address: string }) => (
  <code class="rounded bg-zinc-100 px-1.5 py-0.5 text-xs break-all text-zinc-700">{address}</code>
);
